export const colors = {
    azul: 		"#10069F",
    celeste: 	"#00BFB3",
    amarillo: 	"#FFBE00",
    naranja: 	"#00547C",
    verdeClaro: "#00FF93",
    plomo: 		"#C0C0C0",
    azulOscuro: "#00547C",
}

export const colorsList = [
    "#10069F",
    "#00BFB3",
    "#FFBE00",
    "#00547C",
    "#00FF93",
    "#C0C0C0",
    "#00547C",
]